import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import login from '@/views/login/login'
import home from '@/views/home/home.vue'
import homeContent from '@/views/home/homeContent'
import homeContentTwo from '@/views/home/homeContentTwo'

import coinnum from '@/views/coinnum/coinnum'
import coinnumHome from '@/views/coinnum/coinnumHome'


// 权限配置
import right1 from '@/views/right/right1.vue'
import right2 from '@/views/right/right2.vue'


import memberManagement from '@/views/memberManagement/memberManagement'
import memberManagementContent from '@/views/memberManagement/memberManagementContent'
import memberManagementTop from '@/views/memberManagement/memberManagementTop'
import userPullsNew from '@/views/memberManagement/userPullsNew/userPullsNew'
import playRecord from '@/views/memberManagement/playRecord/playRecord'

// 门店管理
import storeClassification from '@/views/storeManagement/storeClassification/storeClassification'
import storeClassificationTwo from '@/views/storeManagement/storeClassificationTwo/storeClassificationTwo'
import storeManagement from '@/views/storeManagement/storeManagement/storeManagement'
import managementHom from '@/views/storeManagement/storeManagement/managementHom'
//
import storeClassificationThree from '@/views/storeManagement/storeClassificationTwo/storeClassificationThree'
import newStore from '@/views/storeManagement/storeManagement/newStore/newStore'
import edit from '@/views/storeManagement/storeManagement/edit/edit'
// 员工管理
import staffManagement from '@/views/storeManagement/staffManagement/staffManagement'
// 周边商家
import partnerManagement from '@/views/storeManagement/partnerManagement/partnerManagement'
// 机台管理
import deviceManagement from '@/views/storeManagement/deviceManagement/deviceHome'
// 禁用手机管理
import disablePhoneManagement from '@/views/storeManagement/disablePhoneManagement/disablePhoneHome'

import carouselManagement from '@/views/carouselManagement/carouselManagement'
import carouselManagementHome from '@/views/carouselManagement/carouselManagementHome'
import newCarousel from '@/views/carouselManagement/newCarousel/newCarousel'
import newCarousels from '@/views/carouselManagement/newCarousel/newCarousels'

import projectManagement from '@/views/marketingManagement/projectManagement'
import bargainingGoods from '@/views/marketingManagement/merchandising/bargainingGoods/bargainingGoods'
import bargainingGoodsHome from '@/views/marketingManagement/merchandising/bargainingGoods/bargainingGoodsHome'
import addBargain from '@/views/marketingManagement/merchandising/bargainingGoods/addBargain'

import lightningDeals from '@/views/marketingManagement/merchandising/lightningDeals/lightningDeals'
import lightningDealsHome from '@/views/marketingManagement/merchandising/lightningDeals/lightningDealsHome'
import add from '@/views/marketingManagement/merchandising/lightningDeals/add'

import groupGoods from '@/views/marketingManagement/merchandising/groupGoods/groupGoods'
import groupGoodsHome from '@/views/marketingManagement/merchandising/groupGoods/groupGoodsHome'
import groupGoodsAdd from '@/views/marketingManagement/merchandising/groupGoods/groupGoodsAdd'

import tokenPackage from '@/views/marketingManagement/tokenPackage/tokenPackage'
import tokenPackageHome from '@/views/marketingManagement/tokenPackage/tokenPackageHome'
import tokenPackageAdd from '@/views/marketingManagement/tokenPackage/tokenPackageAdd'
import tokenPackageEdit from '@/views/marketingManagement/tokenPackage/tokenPackageEdit'
import tokenPackageAddThree from '@/views/marketingManagement/tokenPackage/tokenPackageAddThree'
import tokenPackageEditThree from '@/views/marketingManagement/tokenPackage/tokenPackageEditThree'

import tokenPackageAdmin from '@/views/marketingManagement/AdminTokenPackage/tokenPackage'
import tokenPackageHomeAdmin from '@/views/marketingManagement/AdminTokenPackage/tokenPackageHome'
import tokenPackageAddAdmin from '@/views/marketingManagement/AdminTokenPackage/tokenPackageAdd'
import tokenPackageEditAdmin from '@/views/marketingManagement/AdminTokenPackage/tokenPackageEdit'

import ticketPackage from '@/views/marketingManagement/ticketPackage/ticketPackage'
import ticketPackageHome from '@/views/marketingManagement/ticketPackage/ticketPackageHome'
import ticketPackageAdd from '@/views/marketingManagement/ticketPackage/ticketPackageAdd'
import ticketPackageDetails from '@/views/marketingManagement/ticketPackage/ticketPackageDetails'
import ticketPackageAddTwo from '@/views/marketingManagement/ticketPackage/ticketPackageAddTwo'

import ticketPackageAdmin from '@/views/marketingManagement/AdminTicketPackage/ticketPackage'
import ticketPackageHomeAdmin from '@/views/marketingManagement/AdminTicketPackage/ticketPackageHome'
import ticketPackageAddTwoAdmin from '@/views/marketingManagement/AdminTicketPackage/ticketPackageAddTwo'


import exchangeManagement from '@/views/marketingManagement/exchangeManagement/exchangeManagement'
import exchangeManagementHome from '@/views/marketingManagement/exchangeManagement/exchangeManagementHome'
import exchangeManagementAdd from '@/views/marketingManagement/exchangeManagement/exchangeManagementAdd'
import goodsCategory from '@/views/marketingManagement/exchangeManagement/goodsCategory'
import eventManagement from '@/views/marketingManagement/eventManagement/eventManagement'
import eventManagementHome from '@/views/marketingManagement/eventManagement/eventManagementHome'
import registrationDetailsHome
  from '@/views/marketingManagement/eventManagement/registrationDetails/registrationDetailsHome'
import addEvent from '@/views/marketingManagement/eventManagement/addEvent/addEvent'

// 角色管理
import partManagement from '@/views/right/partManagement/partManagement'
import partManagementHome from '@/views/right/partManagement/partManagementHome'
import addpartManagement from '@/views/right/partManagement/addpartManagement/addpartManagement'
import EditpartManagement from '@/views/right/partManagement/EditpartManagement/EditpartManagement'

import partManagementTwo from '@/views/right/partManagementTwo/partManagementTwo'
import partManagementHomeTwo from '@/views/right/partManagementTwo/partManagementHomeTwo'
import addpartManagementTwo from '@/views/right/partManagementTwo/addpartManagementTwo/addpartManagementTwo'
import EditpartManagementTwo from '@/views/right/partManagementTwo/EditpartManagementTwo/EditpartManagementTwo'

import iconControl from '@/views/right/iconControl/iconControl'

import offerManagement from '@/views/marketingManagement/offerManagement/offerManagement'
import offerManagementHome from '@/views/marketingManagement/offerManagement/offerManagementHome'
import usageDetailsHome from '@/views/marketingManagement/offerManagement/usageDetails/usageDetailsHome'

///
import distribution from '@/views/marketingManagement/distribution/distribution'
import distributionHome from '@/views/marketingManagement/distribution/distributionHome'
import distributionSettingsHome
  from '@/views/marketingManagement/distribution/distributionSettings/distributionSettingsHome'

import taskManagementHome from '@/views/marketingManagement/taskManagement/taskManagementHome'

import exchangeOrder from '@/views/orderManagement/exchangeOrder'
import orderDetails from '@/views/orderManagement/orderDetails/orderDetails'
import exchangeOrderHome from '@/views/orderManagement/exchangeOrderHome'
import exchangeOrderDetails from '@/views/orderManagement/exchangeOrderDetails'

import exchangeOrderHomeTwo from '@/views/orderManagement/exchangeOrderHomeTwo'
import exchangeOrderDetailsTwo from '@/views/orderManagement/exchangeOrderDetailsTwo'

import groupOrder from '@/views/orderManagement/groupOrder/groupOrder'
import groupOrderHome from '@/views/orderManagement/groupOrder/groupOrderHome'
import groupOrderDetails from '@/views/orderManagement/groupOrder/groupOrderDetails'

import groupOrderTwo from '@/views/orderManagement/groupOrderTwo/groupOrderTwo'
import groupOrderHomeTwo from '@/views/orderManagement/groupOrderTwo/groupOrderHomeTwo'
import groupOrderDetailsTwo from '@/views/orderManagement/groupOrderTwo/groupOrderDetailsTwo'

import seckillOrder from '@/views/orderManagement/seckillOrder/seckillOrder'
import seckillOrderHome from '@/views/orderManagement/seckillOrder/seckillOrderHome'
import seckillOrderDetails from '@/views/orderManagement/seckillOrder/seckillOrderDetails'

// 验票订单
import verificationSlipOrderTwo from '@/views/orderManagement/verificationSlipOrderTwo/verificationSlipOrderTwo'
import verificationSlipOrderHomeTwo from '@/views/orderManagement/verificationSlipOrderTwo/verificationSlipOrderHomeTwo.vue'

// 合作商家订单
import partnerOrderTwo from '@/views/orderManagement/partnerOrderTwo/partnerOrderTwo'
import partnerOrderHomeTwo from '@/views/orderManagement/partnerOrderTwo/partnerOrderHomeTwo.vue'


// 积分记录
import intergralOrder from '@/views/orderManagement/intergralOrder/intergralOrder'
import intergralOrderHome from '@/views/orderManagement/intergralOrder/intergralOrderHome.vue'


// 积分记录
import intergralOrderTwo from '@/views/orderManagement/intergralOrder/intergralOrderTwo'
import intergralOrderHomeTwo from '@/views/orderManagement/intergralOrder/intergralOrderHomeTwo.vue'


// 积分余额
import intergralBalance from '@/views/orderManagement/intergralOrder/intergralBalance'
import intergralBalanceHome from '@/views/orderManagement/intergralOrder/intergralBalanceHome.vue'

// 权限管理
import permissions from '@/views/right/permissions/permissions'
import permissionsHome from '@/views/right/permissions/permissionsHome'
import permissionsDetails from '@/views/right/permissions/permissionsDetails'

// 商家管理
import merchants from '@/views/right/merchants/merchants'
import merchantsHome from '@/views/right/merchants/merchantsHome'


import permissionsTwo from '@/views/right/permissionsTwo/permissionsTwo'
import permissionsHomeTwo from '@/views/right/permissionsTwo/permissionsHomeTwo'
import permissionsDetailsTwo from '@/views/right/permissionsTwo/permissionsDetailsTwo'

import seckillOrderTwo from '@/views/orderManagement/seckillOrderTwo/seckillOrderTwo'
import seckillOrderHomeTwo from '@/views/orderManagement/seckillOrderTwo/seckillOrderHomeTwo'
import seckillOrderDetailsTwo from '@/views/orderManagement/seckillOrderTwo/seckillOrderDetailsTwo'

import bargainingOrder from '@/views/orderManagement/bargainingOrder/bargainingOrder'
import bargainingOrderHome from '@/views/orderManagement/bargainingOrder/bargainingOrderHome'
import bargainingOrderDetails from '@/views/orderManagement/bargainingOrder/bargainingOrderDetails'

import bargainingOrderTwo from '@/views/orderManagement/bargainingOrderTwo/bargainingOrderTwo'
import bargainingOrderHomeTwo from '@/views/orderManagement/bargainingOrderTwo/bargainingOrderHomeTwo'
import bargainingOrderDetailsTwo from '@/views/orderManagement/bargainingOrderTwo/bargainingOrderDetailsTwo'

import tokenOrder from '@/views/orderManagement/tokenOrder/tokenOrder'
import tokenOrderHome from '@/views/orderManagement/tokenOrder/tokenOrderHome'
import tokenOrderDetails from '@/views/orderManagement/tokenOrder/tokenOrderDetails'

import tokenOrderTwo from '@/views/orderManagement/tokenOrderTwo/tokenOrderTwo'
import tokenOrderHomeTwo from '@/views/orderManagement/tokenOrderTwo/tokenOrderHomeTwo'
import tokenOrderDetailsTwo from '@/views/orderManagement/tokenOrderTwo/tokenOrderDetailsTwo'

import ticketOrder from '@/views/orderManagement/ticketOrder/ticketOrder'
import ticketOrderHome from '@/views/orderManagement/ticketOrder/ticketOrderHome'
import ticketOrderDetails from '@/views/orderManagement/ticketOrder/ticketOrderDetails'


import ticketOrderTwo from '@/views/orderManagement/ticketOrderTwo/ticketOrderTwo'
import ticketOrderHomeTwo from '@/views/orderManagement/ticketOrderTwo/ticketOrderHomeTwo'
import ticketOrderDetailsTwo from '@/views/orderManagement/ticketOrderTwo/ticketOrderDetailsTwo'
// 已支付订单
import payForTheOrder from '@/views/orderManagement/payForTheOrder/payForTheOrderHome'
import payForTheOrderDetails from '@/views/orderManagement/payForTheOrder/payForTheOrderHome'

// 按套餐统计
import goodOrderCount from '@/views/orderManagement/goodOrderCount/goodOrderHome'
// 按套餐统计
import mallGoodOrderCount from '@/views/orderManagement/mallGoodOrderCount/mallGoodOrderHome'

import payForTheOrderTwo from '@/views/orderManagement/payForTheOrderTwo/payForTheOrderHomeTwo'
import payForTheOrderDetailsTwo from '@/views/orderManagement/payForTheOrderTwo/payForTheOrderDetailsTwo'

import runningWater from '@/views/financialManagement/runningWater/runningWater'
import orderRevenue from '@/views/financialManagement/orderRevenue/orderRevenue'
import userDalance from '@/views/financialManagement/userDalance/userDalance'
import storeBalance from '@/views/financialManagement/storeBalance/storeBalance'
import billingCycle from '@/views/financialManagement/billingCycle/billingCycle'
import storeWallet from '@/views/financialManagement/storeWallet/storeWallet'
import generalSettings from '@/views/financialManagement/generalSettings/generalSettings'

import withdrawalAudit from '@/views/financialManagement/withdrawalAudit/withdrawalAudit'
import withdrawalAuditHome from '@/views/financialManagement/withdrawalAudit/withdrawalAuditHome'
import withdrawalDetails from '@/views/financialManagement/withdrawalAudit/withdrawalDetails/withdrawalDetails'

import checkinConfiguration from '@/views/systemManagement/checkinConfiguration/checkinConfiguration'
import userCheckinRecord from '@/views/systemManagement/userCheckinRecord/userCheckinRecord'
import completeMissionRecord from '@/views/systemManagement/completeMissionRecord/completeMissionRecord'
import enterpriseCode from '@/views/systemManagement/enterpriseCode/enterpriseCode'
import unbindMember from '@/views/systemManagement/unbindMember/unbindMember'

import feedback from '@/views/systemManagement/feedback/feedback'
import feedbackHome from '@/views/systemManagement/feedback/feedbackHome'
import feedbackDetails from '@/views/systemManagement/feedback/feedbackDetails/feedbackDetails'

import taskCenterRules from '@/views/systemManagement/taskCenterRules/taskCenterRules'
import userAgreement from '@/views/systemManagement/userAgreement/userAgreement'
import taskCenter from '@/views/systemManagement/taskCenter/taskCenter'
import distributorApplication from '@/views/systemManagement/distributorApplication/distributorApplication'
import distributionRule from '@/views/systemManagement/distributionRule/distributionRule'
import privacyAgreement from '@/views/systemManagement/privacyAgreement/privacyAgreement'

import roleManagement from '@/views/systemManagement/roleManagement/roleManagement'
import authorityManagement from '@/views/systemManagement/authorityManagement/authorityManagement'
import proxyAudit from '@/views/proxyAudit/proxyAudit'
import proxyAuditTwo from '@/views/proxyAuditTwo/proxyAuditTwo'

//三方设置
import thirdShopHome from '@/views/thirdShopManagement/thirdShopHome'
import thirdParmsHome from '@/views/thirdShopManagement/thirdParmsHome'

import thirdShopHomeAdmin from '@/views/thirdShopManagementAdmin/thirdShopHomeAdmin'
import thirdParmsHomeAdmin from '@/views/thirdShopManagementAdmin/thirdParmsHomeAdmin'
// 卡类型设置
import cardTypeHome from '@/views/functionSettings/cardType/cardTypeHome'

// 套餐操作日志
import packageLog from '@/views/marketingManagement/packageLog/packageLog'
import packageLogHome from '@/views/marketingManagement/packageLog/packageLogHome'
import packageLogInfo from '@/views/marketingManagement/packageLog/packageLogInfo'

// 套餐操作日志
import packageLogAdmin from '@/views/marketingManagement/packageLogAdmin/packageLog'
import packageLogHomeAdmin from '@/views/marketingManagement/packageLogAdmin/packageLogHome'
import packageLogInfoAdmin from '@/views/marketingManagement/packageLogAdmin/packageLogInfo'

import membershipAgreementHome  from '@/views/systemManagement/membershipAgreement/membershipAgreementHome.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/',
      name: 'login',
      component: login,
      meta: {title: "登录 | 中山市八达动漫科技有限公司"},
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      meta: {title: "首页 | 中山市八达动漫科技有限公司"},
      children: [
        {
          path: 'right1',
          name: 'right1',
          meta: {title: "首页 | 中山市八达动漫科技有限公司"},
          component: right1
        },
        {
          path: 'right2',
          name: 'right2',
          meta: {title: "首页 | 中山市八达动漫科技有限公司"},
          component: right2
        },
        {
          path: 'homeContent',
          name: 'homeContent',
          meta: {title: "首页 | 中山市八达动漫科技有限公司"},
          component: homeContent
        },
        {
          path: 'homeContentTwo',
          name: 'homeContentTwo',
          meta: {title: "首页 | 中山市八达动漫科技有限公司"},
          component: homeContentTwo
        },
        {
          path: 'memberManagement',
          name: 'memberManagement',
          component: memberManagement,
          redirect: 'memberManagement/memberManagementTop',
          meta: {title: "会员管理 | 中山市八达动漫科技有限公司"},
          children: [
            {
              path: 'memberManagementTop',
              name: 'memberManagementTop',
              meta: {title: "会员管理 | 中山市八达动漫科技有限公司"},
              component: () => import('@/views/memberManagement/memberManagementTop')
            },

            {
              path: 'playRecord',
              name: 'playRecord',
              meta: {title: "会员管理 | 游玩记录 | 中山市八达动漫科技有限公司"},
              component: playRecord,
            },
            {
              path: 'userPullsNew',
              name: 'userPullsNew',
              meta: {title: "用户拉新 | 中山市八达动漫科技有限公司"},
              component: userPullsNew,
            },
          ]
        },

        {
          path: 'storeClassification',
          name: 'storeClassification',
          component: storeClassification,
          meta: {title: "门店分类 | 中山市八达动漫科技有限公司"},
        },
        {
          path: 'storeClassificationTwo',
          name: 'storeClassificationTwo',
          meta: {title: "项目分类 | 中山市八达动漫科技有限公司"},
          component: storeClassificationTwo,
        },
        {
          path: 'storeClassificationThree',
          name: 'storeClassificationThree',
          meta: {title: "项目分类 | 中山市八达动漫科技有限公司"},
          component: storeClassificationThree,
        },
        {
          path: 'iconControl',
          name: 'iconControl',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: iconControl,
        },
        {
          path: 'coinnum',
          name: 'coinnum',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: coinnum,
          redirect: "coinnum/coinnumHome",
          children: [
            {
              path: "coinnumHome",
              name: 'coinnumHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: coinnumHome,
            }
          ]
        },
        {
          path: 'storeManagement',
          name: 'storeManagement',
          component: storeManagement,
          redirect: 'storeManagement/managementHom',
          meta: {title: "店铺管理 | 中山市八达动漫科技有限公司"},
          children: [
            {
              path: 'managementHom',
              name: 'managementHom',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: managementHom,
            },

            {
              path: 'newStore',
              name: 'newStore',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: newStore,
            },
            {
              path: 'edit',
              name: 'edit',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: edit,
            },
          ]
        },
        {
          path: 'proxyAudit',
          name: 'proxyAudit',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: proxyAudit,
        },
        {
          path: 'proxyAuditTwo',
          name: 'proxyAuditTwo',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: proxyAuditTwo,
        },
        {
          path: 'carouselManagement',
          name: 'carouselManagement',
          component: carouselManagement,
          meta: {title: "轮播图管理 | 中山市八达动漫科技有限公司"},
          redirect: 'carouselManagement/carouselManagementHome',
          children: [
            {
              path: 'carouselManagementHome',
              name: 'carouselManagementHome',
              meta: {title: "轮播图管理 | 中山市八达动漫科技有限公司"},
              component: carouselManagementHome,
            },
            {
              path: 'newCarousel',
              name: 'newCarousel',
              meta: {title: "新增轮播图 | 中山市八达动漫科技有限公司"},
              component: newCarousel,
            },
            {
              path: 'newCarousels',
              name: 'newCarousels',
              meta: {title: "编辑轮播图 | 中山市八达动漫科技有限公司"},
              component: newCarousels,
            }
          ]
        },
        {
          path: 'projectManagement',
          name: 'projectManagement',
          meta: {title: "编辑轮播图 | 中山市八达动漫科技有限公司"},
          component: projectManagement,
        },
        {
          path: 'bargainingGoods',
          name: 'bargainingGoods',
          component: bargainingGoods,
          meta: {title: "砍价商品 | 中山市八达动漫科技有限公司"},
          redirect: 'bargainingGoods/bargainingGoodsHome',
          children: [
            {
              path: 'bargainingGoodsHome',
              name: 'bargainingGoodsHome',
              meta: {title: "砍价商品 | 中山市八达动漫科技有限公司"},
              component: bargainingGoodsHome,
            },
            {
              path: 'addBargain',
              name: 'addBargain',
              meta: {title: "添加砍价商品 | 中山市八达动漫科技有限公司"},
              component: addBargain,
            }
          ]
        },
        {
          path: 'lightningDeals',
          name: 'lightningDeals',
          component: lightningDeals,
          meta: {title: "秒杀商品 | 中山市八达动漫科技有限公司"},
          redirect: 'lightningDeals/lightningDealsHome',
          children: [
            {
              path: 'lightningDealsHome',
              name: 'lightningDealsHome',
              meta: {title: "秒杀商品 | 中山市八达动漫科技有限公司"},
              component: lightningDealsHome,
            },
            {
              path: 'add',
              name: 'add',
              meta: {title: "添加秒杀商品 | 中山市八达动漫科技有限公司"},
              component: add,
            }
          ]
        },
        {
          path: 'groupGoods',
          name: 'groupGoods',
          component: groupGoods,
          meta: {title: "拼团商品 | 中山市八达动漫科技有限公司"},
          redirect: 'groupGoods/groupGoodsHome',
          children: [
            {
              path: 'groupGoodsHome',
              name: 'groupGoodsHome',
              meta: {title: "拼团商品 | 中山市八达动漫科技有限公司"},
              component: groupGoodsHome,
            },
            {
              path: 'groupGoodsAdd',
              name: 'groupGoodsAdd',
              meta: {title: "添加拼团商品 | 中山市八达动漫科技有限公司"},
              component: groupGoodsAdd,
            }
          ]
        },
        {
          path: 'tokenPackage',
          name: 'tokenPackage',
          component: tokenPackage,
          redirect: 'tokenPackage/tokenPackageHome',
          meta: {title: "代币套餐 | 中山市八达动漫科技有限公司"},
          children: [
            {
              path: 'tokenPackageHome',
              name: 'tokenPackageHome',
              meta: {title: "代币套餐 | 中山市八达动漫科技有限公司"},
              component: tokenPackageHome,
            },
            {
              path: 'tokenPackageAdd',
              name: 'tokenPackageAdd',
              meta: {title: "添加代币套餐 | 中山市八达动漫科技有限公司"},
              component: tokenPackageAdd,
            },
            {
              path: 'tokenPackageEdit',
              name: 'tokenPackageEdit',
              meta: {title: "编辑代币套餐 | 中山市八达动漫科技有限公司"},
              component: tokenPackageEdit,
            },
            {
              path: 'tokenPackageAddThree',
              name: 'tokenPackageAddThree',
              meta: {title: "活动管理 | 中山市八达动漫科技有限公司"},
              component: tokenPackageAddThree,
            },
            {
              path: 'tokenPackageEditThree',
              name: 'tokenPackageEditThree',
              meta: {title: "活动管理 | 中山市八达动漫科技有限公司"},
              component: tokenPackageEditThree,
            },
          ]
        },
        {
          path: 'tokenPackageAdmin',
          name: 'tokenPackageAdmin',
          component: tokenPackageAdmin,
          redirect: 'tokenPackageAdmin/tokenPackageHomeAdmin',
          meta: {title: "代币套餐 | 中山市八达动漫科技有限公司"},
          children: [
            {
              path: 'tokenPackageHomeAdmin',
              name: 'tokenPackageHomeAdmin',
              meta: {title: "代币套餐 | 中山市八达动漫科技有限公司"},
              component: tokenPackageHomeAdmin,
            },
            {
              path: 'tokenPackageAddAdmin',
              name: 'tokenPackageAddAdmin',
              meta: {title: "添加代币套餐 | 中山市八达动漫科技有限公司"},
              component: tokenPackageAddAdmin,
            },
            {
              path: 'tokenPackageEditAdmin',
              name: 'tokenPackageEditAdmin',
              meta: {title: "编辑代币套餐 | 中山市八达动漫科技有限公司"},
              component: tokenPackageEditAdmin,
            },
            
          ]
        },
        {
          path: 'packageLog',
          name: 'packageLog',
          component: packageLog,
          redirect: 'packageLog/packageLogHome',
          meta: {title: "套餐操作日志 | 中山市八达动漫科技有限公司"},
          children: [
            {
              path: 'packageLogHome',
              name: 'packageLogHome',
              meta: {title: "套餐操作日志 | 中山市八达动漫科技有限公司"},
              component: packageLogHome,
            },
            {
              path: 'packageLogInfo',
              name: 'packageLogInfo',
              meta: {title: "套餐操作日志详情 | 中山市八达动漫科技有限公司"},
              component: packageLogInfo,
            },
          ]
        },
          {
          path: 'packageLogAdmin',
          name: 'packageLogAdmin',
          component: packageLogAdmin,
          redirect: 'packageLogAdmin/packageLogHomeAdmin',
          meta: {title: "套餐操作日志 | 中山市八达动漫科技有限公司"},
          children: [
            {
              path: 'packageLogHomeAdmin',
              name: 'packageLogHomeAdmin',
              meta: {title: "套餐操作日志 | 中山市八达动漫科技有限公司"},
              component: packageLogHomeAdmin,
            },
            {
              path: 'packageLogInfoAdmin',
              name: 'packageLogInfoAdmin',
              meta: {title: "套餐操作日志详情 | 中山市八达动漫科技有限公司"},
              component: packageLogInfoAdmin,
            },
          ]
        },
        {
          path: 'ticketPackage',
          name: 'ticketPackage',
          component: ticketPackage,
          meta: {title: "门票套餐 | 中山市八达动漫科技有限公司"},
          redirect: 'ticketPackage/ticketPackageHome',
          children: [
            {
              path: 'ticketPackageHome',
              name: 'ticketPackageHome',
              meta: {title: "门票套餐 | 中山市八达动漫科技有限公司"},
              component: ticketPackageHome,
            },
            {
              path: 'ticketPackageAdd',
              name: 'ticketPackageAdd',
              meta: {title: "添加门票套餐 | 中山市八达动漫科技有限公司"},
              component: ticketPackageAdd,
            },
            {
              path: 'ticketPackageDetails',
              name: 'ticketPackageDetails',
              meta: {title: "门票套餐详情 | 中山市八达动漫科技有限公司"},
              component: ticketPackageDetails,
            },
            {
              path: 'ticketPackageAddTwo',
              name: 'ticketPackageAddTwo',
              meta: {title: "添加门票套餐 | 中山市八达动漫科技有限公司"},
              component: ticketPackageAddTwo,
            }
          ]
        },
        {
          path: 'ticketPackageAdmin',
          name: 'ticketPackageAdmin',
          component: ticketPackageAdmin,
          meta: {title: "门票套餐 | 中山市八达动漫科技有限公司"},
          redirect: 'ticketPackageAdmin/ticketPackageHomeAdmin',
          children: [
            {
              path: 'ticketPackageHomeAdmin',
              name: 'ticketPackageHomeAdmin',
              meta: {title: "门票套餐 | 中山市八达动漫科技有限公司"},
              component: ticketPackageHomeAdmin,
            },
            {
              path: 'ticketPackageAddTwoAdmin',
              name: 'ticketPackageAddTwoAdmin',
              meta: {title: "添加门票套餐 | 中山市八达动漫科技有限公司"},
              component: ticketPackageAddTwoAdmin,
            }
          ]
        },

        {
          path: 'exchangeManagement',
          name: 'exchangeManagement',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: exchangeManagement,
          redirect: 'exchangeManagement/exchangeManagementHome',
          children: [
            {
              path: 'exchangeManagementHome',
              name: 'exchangeManagementHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: exchangeManagementHome,
            },
            {
              path: 'exchangeManagementAdd',
              name: 'exchangeManagementAdd',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: exchangeManagementAdd,
            },
            {
              path: 'goodsCategory',
              name: 'goodsCategory',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: goodsCategory,
            }
          ]
        },
        {
          path: 'eventManagement',
          name: 'eventManagement',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: eventManagement,
          redirect: 'eventManagement/eventManagementHome',
          children: [
            {
              path: 'eventManagementHome',
              name: 'eventManagementHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: eventManagementHome,
            },
            {
              path: 'registrationDetailsHome',
              name: 'registrationDetailsHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: registrationDetailsHome,
            },
            {
              path: 'addEvent',
              name: 'addEvent',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: addEvent,
            }
          ]
        },
        {
          path: 'partManagement',
          name: 'partManagement',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: partManagement,
          redirect: 'partManagement/partManagementHome',
          children: [
            {
              path: 'partManagementHome',
              name: 'partManagementHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: partManagementHome,
            },
            {
              path: 'addpartManagement',
              name: 'addpartManagement',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: addpartManagement,
            },
            {
              path: 'EditpartManagement',
              name: 'EditpartManagement',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: EditpartManagement,
            }
          ]
        },
        {
          path: 'partManagementTwo',
          name: 'partManagementTwo',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: partManagementTwo,
          redirect: 'partManagementTwo/partManagementHomeTwo',
          children: [
            {
              path: 'partManagementHomeTwo',
              name: 'partManagementHomeTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: partManagementHomeTwo,
            },
            {
              path: 'addpartManagementTwo',
              name: 'addpartManagementTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: addpartManagementTwo,
            },
            {
              path: 'EditpartManagementTwo',
              name: 'EditpartManagementTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: EditpartManagementTwo,
            }
          ]
        },
        {
          path: 'offerManagement',
          name: 'offerManagement',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: offerManagement,
          redirect: 'offerManagement/offerManagementHome',
          children: [
            {
              path: 'offerManagementHome',
              name: 'offerManagementHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: offerManagementHome,
            },
            {
              path: 'usageDetailsHome',
              name: 'usageDetailsHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: usageDetailsHome,
            },

          ]
        },

        {
          path: 'taskManagementHome',
          name: 'taskManagementHome',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: taskManagementHome,

        },
        {
          path: 'distribution',
          name: 'distribution',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: distribution,
          redirect: 'distribution/distributionHome',
          children: [
            {
              path: 'distributionHome',
              name: 'distributionHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: distributionHome,
            },
            {
              path: 'distributionSettingsHome',
              name: 'distributionSettingsHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: distributionSettingsHome,
            },

          ]
        },
        {
          path: 'exchangeOrderDetails',
          name: 'exchangeOrderDetails',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: exchangeOrderDetails,
        },

        {
          path: 'exchangeOrder',
          name: 'exchangeOrder',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: exchangeOrder,
          redirect: 'exchangeOrder/exchangeOrderHome',
          children: [
            {
              path: 'exchangeOrderHome',
              name: 'exchangeOrderHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: exchangeOrderHome,
            },
            {
              path: 'orderDetails',
              name: 'orderDetails',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: orderDetails,
            },
          ]
        },
        {
          path: 'exchangeOrderDetailsTwo',
          name: 'exchangeOrderDetailsTwo',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: exchangeOrderDetailsTwo,
        },
        {
          path: 'exchangeOrderHomeTwo',
          name: 'exchangeOrderHomeTwo',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: exchangeOrderHomeTwo,
        },

        {
          path: 'groupOrder',
          name: 'groupOrder',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: groupOrder,
          redirect: 'groupOrder/groupOrderHome',
          children: [
            {
              path: 'groupOrderHome',
              name: 'groupOrderHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: groupOrderHome,
            },
            {
              path: 'groupOrderDetails',
              name: 'groupOrderDetails',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: groupOrderDetails,
            },

          ]
        },
        {
          path: 'groupOrderTwo',
          name: 'groupOrderTwo',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: groupOrderTwo,
          redirect: 'groupOrderTwo/groupOrderHomeTwo',
          children: [
            {
              path: 'groupOrderHomeTwo',
              name: 'groupOrderHomeTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: groupOrderHomeTwo,
            },
            {
              path: 'groupOrderDetailsTwo',
              name: 'groupOrderDetailsTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: groupOrderDetailsTwo,
            },

          ]
        },
        {
          path: 'seckillOrder',
          name: 'seckillOrder',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: seckillOrder,
          redirect: 'seckillOrder/seckillOrderHome',
          children: [
            {
              path: 'seckillOrderHome',
              name: 'seckillOrderHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: seckillOrderHome,
            },
            {
              path: 'seckillOrderDetails',
              name: 'seckillOrderDetails',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: seckillOrderDetails,
            },

          ]
        },
        {
          path: 'seckillOrderTwo',
          name: 'seckillOrderTwo',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: seckillOrderTwo,
          redirect: 'seckillOrderTwo/seckillOrderHomeTwo',
          children: [
            {
              path: 'seckillOrderHomeTwo',
              name: 'seckillOrderHomeTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: seckillOrderHomeTwo,
            },
            {
              path: 'seckillOrderDetailsTwo',
              name: 'seckillOrderDetailsTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: seckillOrderDetailsTwo,
            },

          ]
        },
        {
          path: 'permissions',
          name: 'permissions',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: permissions,
          redirect: 'permissions/permissionsHome',
          children: [
            {
              path: 'permissionsHome',
              name: 'permissionsHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: permissionsHome,
            },
            {
              path: 'permissionsDetails',
              name: 'permissionsDetails',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: permissionsDetails,
            },

          ]
        },
        {
          path: 'merchants',
          name: 'merchants',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: merchants,
          redirect: 'merchants/merchantsHome',
          children: [
            {
              path: 'merchantsHome',
              name: 'merchantsHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: merchantsHome,
            },
          ]
        },
        {
          path: 'permissionsTwo',
          name: 'permissionsTwo',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: permissionsTwo,
          redirect: 'permissionsTwo/permissionsHomeTwo',
          children: [
            {
              path: 'permissionsHomeTwo',
              name: 'permissionsHomeTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: permissionsHomeTwo,
            },
            {
              path: 'permissionsDetailsTwo',
              name: 'permissionsDetailsTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: permissionsDetailsTwo,
            },

          ]
        },
        {
          path: 'bargainingOrder',
          name: 'bargainingOrder',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: bargainingOrder,
          redirect: 'bargainingOrder/bargainingOrderHome',
          children: [
            {
              path: 'bargainingOrderHome',
              name: 'bargainingOrderHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: bargainingOrderHome,
            },
            {
              path: 'bargainingOrderDetails',
              name: 'bargainingOrderDetails',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: bargainingOrderDetails,
            },

          ]
        },
        {
          path: 'bargainingOrderTwo',
          name: 'bargainingOrderTwo',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: bargainingOrderTwo,
          redirect: 'bargainingOrderTwo/bargainingOrderHomeTwo',
          children: [
            {
              path: 'bargainingOrderHomeTwo',
              name: 'bargainingOrderHomeTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: bargainingOrderHomeTwo,
            },
            {
              path: 'bargainingOrderDetailsTwo',
              name: 'bargainingOrderDetailsTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: bargainingOrderDetailsTwo,
            },

          ]
        },
        {
          path: 'tokenOrder',
          name: 'tokenOrder',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: tokenOrder,
          redirect: 'tokenOrder/tokenOrderHome',
          children: [
            {
              path: 'tokenOrderHome',
              name: 'tokenOrderHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: tokenOrderHome,
            },
            {
              path: 'tokenOrderDetails',
              name: 'tokenOrderDetails',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: tokenOrderDetails,
            },

          ]
        },
        {
          path: 'tokenOrderTwo',
          name: 'tokenOrderTwo',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: tokenOrderTwo,
          redirect: 'tokenOrderTwo/tokenOrderHomeTwo',
          children: [
            {
              path: 'tokenOrderHomeTwo',
              name: 'tokenOrderHomeTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: tokenOrderHomeTwo,
            },
            {
              path: 'tokenOrderDetailsTwo',
              name: 'tokenOrderDetailsTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: tokenOrderDetailsTwo,
            },

          ]
        },
        {
          path: 'ticketOrder',
          name: 'ticketOrder',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: ticketOrder,
          redirect: 'ticketOrder/ticketOrderHome',
          children: [
            {
              path: 'ticketOrderHome',
              name: 'ticketOrderHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: ticketOrderHome,
            },
            {
              path: 'ticketOrderDetails',
              name: 'ticketOrderDetails',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: ticketOrderDetails,
            },

          ]
        },
        {
          path: 'ticketOrderTwo',
          name: 'ticketOrderTwo',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: ticketOrderTwo,
          redirect: 'ticketOrderTwo/ticketOrderHomeTwo',
          children: [
            {
              path: 'ticketOrderHomeTwo',
              name: 'ticketOrderHomeTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: ticketOrderHomeTwo,
            },
            {
              path: 'ticketOrderDetailsTwo',
              name: 'ticketOrderDetailsTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: ticketOrderDetailsTwo,
            },

          ]
        },
        {
          path: 'verificationSlipOrderTwo',
          name: 'verificationSlipOrderTwo',
          meta: {title: "三方核销订单 || 中山市八达动漫科技有限公司"},
          component: verificationSlipOrderTwo,
          redirect: 'verificationSlipOrderTwo/verificationSlipOrderHomeTwo',
          children: [
          
            {
              path: 'verificationSlipOrderHomeTwo',
              name: 'verificationSlipOrderHomeTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: verificationSlipOrderHomeTwo,
            },

          ]
        },
        {
          path: 'intergralOrder',
          name: 'intergralOrder',
          meta: {title: "积分记录 || 中山市八达动漫科技有限公司"},
          component: intergralOrder,
          redirect: 'intergralOrder/intergralOrderHome',
          children: [
          
            {
              path: 'intergralOrderHome',
              name: 'intergralOrderHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: intergralOrderHome,
            },

          ]
        },
         {
          path: 'intergralOrderTwo',
          name: 'intergralOrderTwo',
          meta: {title: "积分记录 || 中山市八达动漫科技有限公司"},
          component: intergralOrderTwo,
          redirect: 'intergralOrderTwo/intergralOrderHomeTwo',
          children: [
          
            {
              path: 'intergralOrderHomeTwo',
              name: 'intergralOrderHomeTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: intergralOrderHomeTwo,
            },

          ]
        },
        {
          path: 'partnerOrderTwo',
          name: 'partnerOrderTwo',
          meta: {title: "三方核销订单 || 中山市八达动漫科技有限公司"},
          component: partnerOrderTwo,
          redirect: 'partnerOrderTwo/partnerOrderHomeTwo',
          children: [
          
            {
              path: 'partnerOrderHomeTwo',
              name: 'partnerOrderHomeTwo',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: partnerOrderHomeTwo,
            },

          ]
        },
        {
          path: 'intergralBalance',
          name: 'intergralBalance',
          meta: {title: "积分余额 || 中山市八达动漫科技有限公司"},
          component: intergralBalance,
          redirect: 'intergralBalance/intergralBalanceHome',
          children: [
          
            {
              path: 'intergralBalanceHome',
              name: 'intergralBalanceHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: intergralBalanceHome,
            },

          ]
        },
         {
          path: 'cardTypeHome',
          name: 'cardTypeHome',
          meta: {title: "会员卡类型管理 | 中山市八达动漫科技有限公司"},
          component: cardTypeHome,
        },
         {
          path: 'goodOrderCount',
          name: 'goodOrderCount',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: goodOrderCount,
        },
          {
          path: 'mallGoodOrderCount',
          name: 'mallGoodOrderCount',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: mallGoodOrderCount,
        },
        {
          path: 'payForTheOrder',
          name: 'payForTheOrder',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: payForTheOrder,
        },
        {
          path: 'payForTheOrderDetails',
          name: 'payForTheOrderDetails',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: payForTheOrderDetails,
        },
        {
          path: 'payForTheOrderTwo',
          name: 'payForTheOrderTwo',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: payForTheOrderTwo,
        },
        {
          path: 'payForTheOrderDetailsTwo',
          name: 'payForTheOrderDetailsTwo',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: payForTheOrderDetailsTwo,
        },
        {
          path: 'runningWater',
          name: 'runningWater',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: runningWater,
        },
        {
          path: 'orderRevenue',
          name: 'orderRevenue',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: orderRevenue,
        },
        {
          path: 'userDalance',
          name: 'userDalance',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: userDalance,
        },
        {
          path: 'storeBalance',
          name: 'storeBalance',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: storeBalance,
        },

        {
          path: 'billingCycle',
          name: 'billingCycle',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: billingCycle,
        },

        {
          path: 'storeWallet',
          name: 'storeWallet',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: storeWallet,
        },

        {
          path: 'generalSettings',
          name: 'generalSettings',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: generalSettings,
        },
        {
          path: 'withdrawalAudit',
          name: 'withdrawalAudit',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: withdrawalAudit,
          redirect: 'withdrawalAudit/withdrawalAuditHome',
          children: [
            {
              path: 'withdrawalAuditHome',
              name: 'withdrawalAuditHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: withdrawalAuditHome,
            },
            {
              path: 'withdrawalDetails',
              name: 'withdrawalDetails',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: withdrawalDetails,
            },

          ]
        },
        {
          path: 'checkinConfiguration',
          name: 'checkinConfiguration',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: checkinConfiguration,
        },
        {
          path: 'userCheckinRecord',
          name: 'userCheckinRecord',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: userCheckinRecord,
        },
        {
          path: 'enterpriseCode',
          name: 'enterpriseCode',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: enterpriseCode,
        },
        {
          path: 'unbindMember',
          name: 'unbindMember',
          meta: {title: "解绑会员卡 | 中山市八达动漫科技有限公司"},
          component: unbindMember,
        },
        // 门店
        {
          path: 'thirdShopManagement',
          name: 'thirdShopHome',
          meta: {title: "第三方商户设置 | 中山市八达动漫科技有限公司"},
          component: thirdShopHome,
        },
        // 门店
        {
          path: 'thirdParmsHome',
          name: 'thirdParmsHome',
          meta: {title: "第三方套餐设置 | 中山市八达动漫科技有限公司"},
          component: thirdParmsHome,
        },
        // 后台
        {
          path: 'thirdShopManagementAdmin',
          name: 'thirdShopHomeAdmin',
          meta: {title: "第三方商户设置 | 中山市八达动漫科技有限公司"},
          component: thirdShopHomeAdmin,
        },
        // 后台
        {
          path: 'thirdParmsHomeAdmin',
          name: 'thirdParmsHomeAdmin',
          meta: {title: "第三方套餐设置 | 中山市八达动漫科技有限公司"},
          component: thirdParmsHomeAdmin,
        },
        {
          path: 'completeMissionRecord',
          name: 'completeMissionRecord',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: completeMissionRecord,
        },
        {
          path: 'feedback',
          name: 'feedback',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: feedback,
          redirect: 'feedback/feedbackHome',
          children: [
            {
              path: 'feedbackHome',
              name: 'feedbackHome',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: feedbackHome,
            },
            {
              path: 'feedbackDetails',
              name: 'feedbackDetails',
              meta: {title: "中山市八达动漫科技有限公司"},
              component: feedbackDetails,
            },

          ]
        },

        {
          path: 'taskCenterRules',
          name: 'taskCenterRules',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: taskCenterRules,
        },
        {
          path: 'userAgreement',
          name: 'userAgreement',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: userAgreement,
        },
        {
          path: 'taskCenter',
          name: 'taskCenter',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: taskCenter,
        },
        {
          path: 'distributorApplication',
          name: 'distributorApplication',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: distributorApplication,
        },
        {
          path: 'distributionRule',
          name: 'distributionRule',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: distributionRule,
        },
        {
          path: 'privacyAgreement',
          name: 'privacyAgreement',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: privacyAgreement,
        },

        {
          path: 'roleManagement',
          name: 'roleManagement',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: roleManagement,
        },
        {
          path: 'authorityManagement',
          name: 'authorityManagement',
          meta: {title: "中山市八达动漫科技有限公司"},
          component: authorityManagement,
        },
        {
          path: 'staffManagement',
          name: 'staffManagement',
          meta: {title: "员工管理 | 中山市八达动漫科技有限公司"},
          component: staffManagement,
        },
        {
          path: 'partnerManagement',
          name: 'partnerManagement',
          meta: {title: "周边商家 | 中山市八达动漫科技有限公司"},
          component: partnerManagement,
        },
        {
          path: 'membershipAgreement',
          name: 'membershipAgreement',
          meta: {title: "会员协议 | 中山市八达动漫科技有限公司"},
          component: membershipAgreementHome,
        },
        {
          path: 'deviceManagement',
          name: 'deviceManagement',
          meta: {title: "机台管理 | 中山市八达动漫科技有限公司"},
          component: deviceManagement,
        },
        {
          path: 'disablePhoneManagement',
          name: 'disablePhoneManagement',
          meta: {title: "禁用手机号码 | 中山市八达动漫科技有限公司"},
          component: disablePhoneManagement,
        },
       
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js